"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * UsersApi - axios parameter creator
 * @export
 */
const UsersApiAxiosParamCreator = function (axiosClientConfiguration) {
    return {
        /**
         * Set the user property \'active\' to true. Trigger a workflow event.
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling activateUser.');
            }
            const localVarPath = `/users/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Authenticate user with email and password
         * @param {LoginUserDtoDto} loginUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUserWithPassword: (loginUserDto, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'loginUserDto' is not null or undefined
            if (loginUserDto === null || loginUserDto === undefined) {
                throw new base_1.RequiredError('loginUserDto', 'Required parameter loginUserDto was null or undefined when calling authenticateUserWithPassword.');
            }
            const localVarPath = `/me/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof loginUserDto !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(loginUserDto !== undefined ? loginUserDto : {})
                : (loginUserDto || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update users password
         * @param {NewPasswordDtoDto} newPasswordDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: (newPasswordDto, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'newPasswordDto' is not null or undefined
            if (newPasswordDto === null || newPasswordDto === undefined) {
                throw new base_1.RequiredError('newPasswordDto', 'Required parameter newPasswordDto was null or undefined when calling changePassword.');
            }
            const localVarPath = `/me/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof newPasswordDto !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(newPasswordDto !== undefined ? newPasswordDto : {})
                : (newPasswordDto || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Verify email confirmation token.
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail: (token, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling confirmEmail.');
            }
            const localVarPath = `/verify/email/confirm/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates (and returns) a new access token for the currently logged in user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: (translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/me/auth/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UserDto} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: (user, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new base_1.RequiredError('user', 'Required parameter user was null or undefined when calling createUser.');
            }
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof user !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(user !== undefined ? user : {})
                : (user || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the user property \'active\' to false and remove the users access tokens. Trigger a workflow event.
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deactivateUser.');
            }
            const localVarPath = `/users/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes an access token
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessToken: (token, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling deleteAccessToken.');
            }
            const localVarPath = `/me/auth/tokens/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyUsers: (ids, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new base_1.RequiredError('ids', 'Required parameter ids was null or undefined when calling deleteManyUsers.');
            }
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteUser.');
            }
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns all access tokens for the currently logged in user (not service or login tokens)
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokens: (translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/me/auth/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} inviteId
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitation: (inviteId, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'inviteId' is not null or undefined
            if (inviteId === null || inviteId === undefined) {
                throw new base_1.RequiredError('inviteId', 'Required parameter inviteId was null or undefined when calling getMyInvitation.');
            }
            const localVarPath = `/me/invitations/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all information that you\'ve received
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations: (translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/me/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPermissions: (translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/me/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get my user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUser: (translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (id, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getUser.');
            }
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: (page, size, translate, sort, search, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCount: (page, size, sort, search, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Afterwards, the current logged in user will (also) be able to login with the given MS AzureAD account.
         * @summary Merges an already authenticated account with Microsoft Azure AD login
         * @param {AzureMergeRequestDto} azureMergeRequest
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeAccountWithMicrosoft: (azureMergeRequest, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'azureMergeRequest' is not null or undefined
            if (azureMergeRequest === null || azureMergeRequest === undefined) {
                throw new base_1.RequiredError('azureMergeRequest', 'Required parameter azureMergeRequest was null or undefined when calling mergeAccountWithMicrosoft.');
            }
            const localVarPath = `/me/auth/merge/azure-ad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof azureMergeRequest !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(azureMergeRequest !== undefined ? azureMergeRequest : {})
                : (azureMergeRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates your own user profile by replacing specific properties. Does not work for arrays.
         * @param {PatchUserDtoDto} patchUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMyUser: (patchUserDto, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'patchUserDto' is not null or undefined
            if (patchUserDto === null || patchUserDto === undefined) {
                throw new base_1.RequiredError('patchUserDto', 'Required parameter patchUserDto was null or undefined when calling patchMyUser.');
            }
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof patchUserDto !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(patchUserDto !== undefined ? patchUserDto : {})
                : (patchUserDto || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {any} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: (id, user, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling patchUser.');
            }
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new base_1.RequiredError('user', 'Required parameter user was null or undefined when calling patchUser.');
            }
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof user !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(user !== undefined ? user : {})
                : (user || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {UserDto} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUser: (id, user, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling putUser.');
            }
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new base_1.RequiredError('user', 'Required parameter user was null or undefined when calling putUser.');
            }
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof user !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(user !== undefined ? user : {})
                : (user || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Register a new user
         * @param {RegisterUserDtoDto} registerUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser: (registerUserDto, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registerUserDto' is not null or undefined
            if (registerUserDto === null || registerUserDto === undefined) {
                throw new base_1.RequiredError('registerUserDto', 'Required parameter registerUserDto was null or undefined when calling registerUser.');
            }
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof registerUserDto !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(registerUserDto !== undefined ? registerUserDto : {})
                : (registerUserDto || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes all connected Microsoft Azure AD logins from the account
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMicrosoftLogin: (translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/me/auth/remove/azure-ad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sends a user an email verification link
         * @param {string} userId
         * @param {EmailVerificationDtoDto} emailVerificationDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailVerification: (userId, emailVerificationDto, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling sendEmailVerification.');
            }
            // verify required parameter 'emailVerificationDto' is not null or undefined
            if (emailVerificationDto === null || emailVerificationDto === undefined) {
                throw new base_1.RequiredError('emailVerificationDto', 'Required parameter emailVerificationDto was null or undefined when calling sendEmailVerification.');
            }
            const localVarPath = `/verify/{userId}/email/send`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof emailVerificationDto !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(emailVerificationDto !== undefined ? emailVerificationDto : {})
                : (emailVerificationDto || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sends a password reset mail to the given mail address
         * @param {ResetPasswordBodyDto} resetPasswordBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordMail: (resetPasswordBody, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            if (resetPasswordBody === null || resetPasswordBody === undefined) {
                throw new base_1.RequiredError('resetPasswordBody', 'Required parameter resetPasswordBody was null or undefined when calling sendResetPasswordMail.');
            }
            const localVarPath = `/me/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof resetPasswordBody !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resetPasswordBody !== undefined ? resetPasswordBody : {})
                : (resetPasswordBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sends a password reset mail to the given mail address
         * @param {ResetPasswordBodyDto} resetPasswordBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordMailForUser: (resetPasswordBody, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            if (resetPasswordBody === null || resetPasswordBody === undefined) {
                throw new base_1.RequiredError('resetPasswordBody', 'Required parameter resetPasswordBody was null or undefined when calling sendResetPasswordMailForUser.');
            }
            const localVarPath = `/users/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof resetPasswordBody !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resetPasswordBody !== undefined ? resetPasswordBody : {})
                : (resetPasswordBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates a password with a reset password token and returns a login token
         * @param {ResetPasswordWithTokenBodyDto} resetPasswordWithTokenBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPasswordWithResetToken: (resetPasswordWithTokenBody, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resetPasswordWithTokenBody' is not null or undefined
            if (resetPasswordWithTokenBody === null || resetPasswordWithTokenBody === undefined) {
                throw new base_1.RequiredError('resetPasswordWithTokenBody', 'Required parameter resetPasswordWithTokenBody was null or undefined when calling setPasswordWithResetToken.');
            }
            const localVarPath = `/me/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof resetPasswordWithTokenBody !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resetPasswordWithTokenBody !== undefined ? resetPasswordWithTokenBody : {})
                : (resetPasswordWithTokenBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates your own user profile by replacing the entire profile.
         * @param {any} profile The own users profile
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile: (profile, translate, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'profile' is not null or undefined
            if (profile === null || profile === undefined) {
                throw new base_1.RequiredError('profile', 'Required parameter profile was null or undefined when calling updateMyProfile.');
            }
            const localVarPath = `/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (translate !== undefined) {
                localVarQueryParameter['translate'] = translate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof profile !== 'string';
            const needsSerialization = nonString && axiosClientConfiguration && axiosClientConfiguration.isJsonMime
                ? axiosClientConfiguration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(profile !== undefined ? profile : {})
                : (profile || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is a very performant method for checking if a User exists.
         * @summary Check if User exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists: (id, options = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling userExists.');
            }
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (axiosClientConfiguration) {
                baseOptions = axiosClientConfiguration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            if (axiosClientConfiguration && axiosClientConfiguration.accessToken) {
                const accessToken = typeof axiosClientConfiguration.accessToken === 'function'
                    ? yield axiosClientConfiguration.accessToken()
                    : yield axiosClientConfiguration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UsersApiAxiosParamCreator = UsersApiAxiosParamCreator;
/**
 * UsersApi - functional programming interface
 * @export
 */
const UsersApiFp = function (axiosClientConfiguration) {
    return {
        /**
         * Set the user property \'active\' to true. Trigger a workflow event.
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).activateUser(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Authenticate user with email and password
         * @param {LoginUserDtoDto} loginUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUserWithPassword(loginUserDto, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).authenticateUserWithPassword(loginUserDto, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Update users password
         * @param {NewPasswordDtoDto} newPasswordDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(newPasswordDto, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).changePassword(newPasswordDto, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Verify email confirmation token.
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(token, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).confirmEmail(token, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Creates (and returns) a new access token for the currently logged in user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).createAccessToken(translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UserDto} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(user, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).createUser(user, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Set the user property \'active\' to false and remove the users access tokens. Trigger a workflow event.
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).deactivateUser(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Deletes an access token
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessToken(token, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).deleteAccessToken(token, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyUsers(ids, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).deleteManyUsers(ids, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).deleteUser(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Returns all access tokens for the currently logged in user (not service or login tokens)
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokens(translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getAccessTokens(translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} inviteId
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitation(inviteId, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getMyInvitation(inviteId, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Get all information that you\'ve received
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations(translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getMyInvitations(translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPermissions(translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getMyPermissions(translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Get my user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUser(translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getMyUser(translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getUser(id, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(page, size, translate, sort, search, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getUsers(page, size, translate, sort, search, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCount(page, size, sort, search, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).getUsersCount(page, size, sort, search, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Afterwards, the current logged in user will (also) be able to login with the given MS AzureAD account.
         * @summary Merges an already authenticated account with Microsoft Azure AD login
         * @param {AzureMergeRequestDto} azureMergeRequest
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeAccountWithMicrosoft(azureMergeRequest, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).mergeAccountWithMicrosoft(azureMergeRequest, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Updates your own user profile by replacing specific properties. Does not work for arrays.
         * @param {PatchUserDtoDto} patchUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMyUser(patchUserDto, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).patchMyUser(patchUserDto, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {any} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser(id, user, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).patchUser(id, user, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {UserDto} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUser(id, user, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).putUser(id, user, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Register a new user
         * @param {RegisterUserDtoDto} registerUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser(registerUserDto, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).registerUser(registerUserDto, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Removes all connected Microsoft Azure AD logins from the account
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMicrosoftLogin(translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).removeMicrosoftLogin(translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Sends a user an email verification link
         * @param {string} userId
         * @param {EmailVerificationDtoDto} emailVerificationDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailVerification(userId, emailVerificationDto, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).sendEmailVerification(userId, emailVerificationDto, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Sends a password reset mail to the given mail address
         * @param {ResetPasswordBodyDto} resetPasswordBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordMail(resetPasswordBody, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).sendResetPasswordMail(resetPasswordBody, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Sends a password reset mail to the given mail address
         * @param {ResetPasswordBodyDto} resetPasswordBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordMailForUser(resetPasswordBody, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).sendResetPasswordMailForUser(resetPasswordBody, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Updates a password with a reset password token and returns a login token
         * @param {ResetPasswordWithTokenBodyDto} resetPasswordWithTokenBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPasswordWithResetToken(resetPasswordWithTokenBody, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).setPasswordWithResetToken(resetPasswordWithTokenBody, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * Updates your own user profile by replacing the entire profile.
         * @param {any} profile The own users profile
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile(profile, translate, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).updateMyProfile(profile, translate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         * This is a very performant method for checking if a User exists.
         * @summary Check if User exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists(id, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.UsersApiAxiosParamCreator)(axiosClientConfiguration).userExists(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((axiosClientConfiguration === null || axiosClientConfiguration === void 0 ? void 0 : axiosClientConfiguration.basePath) || basePath) + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 * @export
 */
const UsersApiFactory = function (axiosClientConfiguration, basePath, axios) {
    return {
        /**
         * Set the user property \'active\' to true. Trigger a workflow event.
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(id, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).activateUser(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Authenticate user with email and password
         * @param {LoginUserDtoDto} loginUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUserWithPassword(loginUserDto, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).authenticateUserWithPassword(loginUserDto, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update users password
         * @param {NewPasswordDtoDto} newPasswordDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(newPasswordDto, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).changePassword(newPasswordDto, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify email confirmation token.
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(token, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).confirmEmail(token, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates (and returns) a new access token for the currently logged in user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).createAccessToken(translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserDto} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(user, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).createUser(user, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the user property \'active\' to false and remove the users access tokens. Trigger a workflow event.
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser(id, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).deactivateUser(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes an access token
         * @param {string} token
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessToken(token, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).deleteAccessToken(token, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyUsers(ids, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).deleteManyUsers(ids, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(id, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).deleteUser(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns all access tokens for the currently logged in user (not service or login tokens)
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessTokens(translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getAccessTokens(translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} inviteId
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitation(inviteId, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getMyInvitation(inviteId, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all information that you\'ve received
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations(translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getMyInvitations(translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPermissions(translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getMyPermissions(translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get my user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyUser(translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getMyUser(translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(id, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getUser(id, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [translate]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(page, size, translate, sort, search, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getUsers(page, size, translate, sort, search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {string} [search]
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersCount(page, size, sort, search, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).getUsersCount(page, size, sort, search, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Afterwards, the current logged in user will (also) be able to login with the given MS AzureAD account.
         * @summary Merges an already authenticated account with Microsoft Azure AD login
         * @param {AzureMergeRequestDto} azureMergeRequest
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeAccountWithMicrosoft(azureMergeRequest, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).mergeAccountWithMicrosoft(azureMergeRequest, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates your own user profile by replacing specific properties. Does not work for arrays.
         * @param {PatchUserDtoDto} patchUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMyUser(patchUserDto, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).patchMyUser(patchUserDto, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {any} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser(id, user, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).patchUser(id, user, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UserDto} user
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUser(id, user, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).putUser(id, user, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Register a new user
         * @param {RegisterUserDtoDto} registerUserDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser(registerUserDto, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).registerUser(registerUserDto, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes all connected Microsoft Azure AD logins from the account
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMicrosoftLogin(translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).removeMicrosoftLogin(translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a user an email verification link
         * @param {string} userId
         * @param {EmailVerificationDtoDto} emailVerificationDto
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailVerification(userId, emailVerificationDto, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).sendEmailVerification(userId, emailVerificationDto, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sends a password reset mail to the given mail address
         * @param {ResetPasswordBodyDto} resetPasswordBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordMail(resetPasswordBody, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).sendResetPasswordMail(resetPasswordBody, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sends a password reset mail to the given mail address
         * @param {ResetPasswordBodyDto} resetPasswordBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordMailForUser(resetPasswordBody, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).sendResetPasswordMailForUser(resetPasswordBody, translate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates a password with a reset password token and returns a login token
         * @param {ResetPasswordWithTokenBodyDto} resetPasswordWithTokenBody
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPasswordWithResetToken(resetPasswordWithTokenBody, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).setPasswordWithResetToken(resetPasswordWithTokenBody, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates your own user profile by replacing the entire profile.
         * @param {any} profile The own users profile
         * @param {string} [translate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfile(profile, translate, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).updateMyProfile(profile, translate, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a very performant method for checking if a User exists.
         * @summary Check if User exists
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists(id, options) {
            return (0, exports.UsersApiFp)(axiosClientConfiguration).userExists(id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
class UsersApi extends base_1.BaseAPI {
    /**
     * Set the user property \'active\' to true. Trigger a workflow event.
     * @param {UsersApiActivateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    activateUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).activateUser(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Authenticate user with email and password
     * @param {UsersApiAuthenticateUserWithPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    authenticateUserWithPassword(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).authenticateUserWithPassword(requestParameters.loginUserDto, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update users password
     * @param {UsersApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    changePassword(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).changePassword(requestParameters.newPasswordDto, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Verify email confirmation token.
     * @param {UsersApiConfirmEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    confirmEmail(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).confirmEmail(requestParameters.token, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates (and returns) a new access token for the currently logged in user
     * @param {UsersApiCreateAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createAccessToken(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).createAccessToken(requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).createUser(requestParameters.user, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the user property \'active\' to false and remove the users access tokens. Trigger a workflow event.
     * @param {UsersApiDeactivateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deactivateUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).deactivateUser(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes an access token
     * @param {UsersApiDeleteAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteAccessToken(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).deleteAccessToken(requestParameters.token, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiDeleteManyUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteManyUsers(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).deleteManyUsers(requestParameters.ids, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).deleteUser(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns all access tokens for the currently logged in user (not service or login tokens)
     * @param {UsersApiGetAccessTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAccessTokens(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getAccessTokens(requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiGetMyInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMyInvitation(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getMyInvitation(requestParameters.inviteId, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all information that you\'ve received
     * @param {UsersApiGetMyInvitationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMyInvitations(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getMyInvitations(requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiGetMyPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMyPermissions(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getMyPermissions(requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get my user
     * @param {UsersApiGetMyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getMyUser(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getMyUser(requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getUser(requestParameters.id, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUsers(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getUsers(requestParameters.page, requestParameters.size, requestParameters.translate, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiGetUsersCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUsersCount(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).getUsersCount(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.search, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Afterwards, the current logged in user will (also) be able to login with the given MS AzureAD account.
     * @summary Merges an already authenticated account with Microsoft Azure AD login
     * @param {UsersApiMergeAccountWithMicrosoftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    mergeAccountWithMicrosoft(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).mergeAccountWithMicrosoft(requestParameters.azureMergeRequest, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates your own user profile by replacing specific properties. Does not work for arrays.
     * @param {UsersApiPatchMyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    patchMyUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).patchMyUser(requestParameters.patchUserDto, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiPatchUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    patchUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).patchUser(requestParameters.id, requestParameters.user, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UsersApiPutUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    putUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).putUser(requestParameters.id, requestParameters.user, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Register a new user
     * @param {UsersApiRegisterUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    registerUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).registerUser(requestParameters.registerUserDto, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes all connected Microsoft Azure AD logins from the account
     * @param {UsersApiRemoveMicrosoftLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    removeMicrosoftLogin(requestParameters = {}, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).removeMicrosoftLogin(requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends a user an email verification link
     * @param {UsersApiSendEmailVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    sendEmailVerification(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).sendEmailVerification(requestParameters.userId, requestParameters.emailVerificationDto, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sends a password reset mail to the given mail address
     * @param {UsersApiSendResetPasswordMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    sendResetPasswordMail(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).sendResetPasswordMail(requestParameters.resetPasswordBody, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sends a password reset mail to the given mail address
     * @param {UsersApiSendResetPasswordMailForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    sendResetPasswordMailForUser(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).sendResetPasswordMailForUser(requestParameters.resetPasswordBody, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates a password with a reset password token and returns a login token
     * @param {UsersApiSetPasswordWithResetTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    setPasswordWithResetToken(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).setPasswordWithResetToken(requestParameters.resetPasswordWithTokenBody, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates your own user profile by replacing the entire profile.
     * @param {UsersApiUpdateMyProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateMyProfile(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).updateMyProfile(requestParameters.profile, requestParameters.translate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is a very performant method for checking if a User exists.
     * @summary Check if User exists
     * @param {UsersApiUserExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    userExists(requestParameters, options) {
        return (0, exports.UsersApiFp)(this.axiosClientConfiguration).userExists(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UsersApi = UsersApi;
